import { Component, OnInit, AfterContentInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { PageWiseIntroText } from '../security/menu-entity';
import { EnUserTypes } from '../security/page-name.enum';
import { DictionaryPipe } from '../../shared/pipes/dictionary.pipe';
import { AuthService } from '@auth0/auth0-angular';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-left-menu',
    templateUrl: './left-menu.component.html',
    styleUrls: ['./left-menu.component.scss'],
    providers: [DictionaryPipe],
    standalone: false
})
export class LeftMenuComponent implements OnInit {

  menuIcons = {
    HOME: 'fa-home',
    INBOX: 'fa-envelope',
    CLIENTSEARCH: 'fa-search',
    FORMS: 'fa-file-alt',
    CLIENTSTATEMENTS: 'fa-sticky-note',
    REPSTATEMENTS: 'fa-sticky-note',
    STATEMENTS: 'fa-sticky-note',
    TAX: 'fa-landmark',
    INVESTMENTS: 'fa-chart-line',
    REPORTS: 'fa-file-contract',
    PROXY: 'fa-check-square',
  };

  public isCollapsed = false;
  public collapsed = true;
  public collapsedOnDesktop;
  public currentUrl = '';
  menuEntityList: PageWiseIntroText[] = [];
  notIsLoggedIn = true;
  differentLoggedIn = false;
  backButtonText: string;
  @Output() collapseChanged = new EventEmitter<boolean>();
  @Output() openFaq = new EventEmitter<boolean>();
  profileOwnershipTitle: string;

  constructor(private router: Router,
              private authService: AuthServiceCustom,
              private route: ActivatedRoute,
              private dictionaryPipe: DictionaryPipe,
              private authOKTA: AuthService,
              private location: Location
  ) {
  }

  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }

  ngOnInit() {
    this.authService.clientBkrSubj.subscribe(() => {
      this.updateMenu();
    });


    this.authService.routeChangedSubj.subscribe((posts) => {
      this.currentUrl = posts.split('?')[0];
      if (this.currentUrl.startsWith('/')) {
        this.currentUrl = this.currentUrl.substring(1);
      }
    });

    if (!this.menuEntityList || this.menuEntityList.length < 1) {
      this.notIsLoggedIn = !this.authService.isAuthenticated;
    } else {
      this.notIsLoggedIn = false;
    }

    this.updateMenu();

    this.authService.accessTokenRemovedSubj.subscribe((posts) => {
      this.notIsLoggedIn = posts;
      if (!this.notIsLoggedIn) {
        this.menuEntityList = this.authService.getMenuListBasedOnUserType();
      }
      this.updateMenu();
    });
  }

  navigateToPage(menuItem: PageWiseIntroText) {
    if (!this.collapsed) {
      this.collapsed = true;
    }

    this.authService.navigateToUrl(menuItem.Path, menuItem.PathParam);
  }

  navigateToUrl(url: string): void {
    this.router.navigate([url]);
  }

  backOriginPage() {
    // Handle everything from auth service
    this.authService.backToPreviousInUse();
  }

  collapseOnDesktop(): void {
    this.collapsedOnDesktop = !this.collapsedOnDesktop;
    this.collapseChanged.emit(this.collapsedOnDesktop);
  }

  private updateMenu(): void {
    this.differentLoggedIn = this.authService.DifferentLoggedIn;
    this.backButtonText = this.getMenuTextByUserType(this.authService.UserType);

    const isCurrentUserProfile = this.route.snapshot.data.currentUserProfile || !this.authService.PreviousLoggedInUser;
    this.profileOwnershipTitle = isCurrentUserProfile
      ? this.dictionaryPipe.transform('MY')
      : this.getUserTypeTitle(this.authService.UserType);

    this.menuEntityList = this.authService.getMenuListBasedOnUserType()
      .map(m => {
        if (m.PageName === 'HOME' && !isCurrentUserProfile) {
          const obj = JSON.parse(JSON.stringify(m));
          obj.MenuTitle = `${obj.MenuTitle} (${(this.minimizeUserName(this.authService.UserName))})`;
          return obj;
        }
        return m;
      });

  }

  minimizeUserName(name: string): string {
    if (name.length && name.length > 14) {
      return name.slice(0, 14) + '...';

    } else {
      return name;
    }
  }

  private getUserTypeTitle(userType: string): string {
    switch (userType) {
      case EnUserTypes.Investor:
        return this.dictionaryPipe.transform('INVESTOR');
      case EnUserTypes.Broker:
        return this.dictionaryPipe.transform('BROKER');
      case EnUserTypes.Custodian:
        return this.dictionaryPipe.transform('CUSTODIAN');
      case EnUserTypes.Rep:
        return this.dictionaryPipe.transform('REP');
      case EnUserTypes.Territory:
        return this.dictionaryPipe.transform('TERRITORY');
      case EnUserTypes.User:
        return this.dictionaryPipe.transform('USER');
      case EnUserTypes.DupMail:
        return this.dictionaryPipe.transform('DUPMAIL');
    }
  }

  private getMenuTextByUserType(userType: string): string {
    switch (userType) {
      case EnUserTypes.Investor:
        return this.dictionaryPipe.transform('BACK_TO_INVESTOR_LIST');
      case EnUserTypes.Broker:
        return this.dictionaryPipe.transform('BACK_TO_BROKER_LIST');
      case EnUserTypes.Custodian:
        return this.dictionaryPipe.transform('BACK_TO_CUSTODIAN_LIST');
      case EnUserTypes.Rep:
        return this.dictionaryPipe.transform('BACK_TO_REP_LIST');
      case EnUserTypes.Territory:
        return this.dictionaryPipe.transform('BACK_TO_TERRITORY_LIST');
      case EnUserTypes.User:
        return this.dictionaryPipe.transform('BACK_TO_USER_LIST');
      case EnUserTypes.DupMail:
        return this.dictionaryPipe.transform('BACK_TO_DUPMAIL_LIST');
    }
  }

  logout() {

    this.authOKTA.logout({
      logoutParams: {
        returnTo: environment.logout.replace(/\/?$/, '/') // this.location.prepareExternalUrl('')
      }
    });

    this.authService.logout();
  }
}
